import deepEqual from 'react-fast-compare';

// Created function to retain identity of object until it really changes
export const makeMemoizeObject = <T,>(): ((o: T) => T) => {
  let lastObject: T | null = null;

  return (o: T): T => {
    if (lastObject === null || !deepEqual(o, lastObject)) {
      lastObject = o;
    }

    return lastObject;
  };
};
